import { render, staticRenderFns } from "./myBanner.vue?vue&type=template&id=0d545da4&scoped=true"
import script from "./myBanner.vue?vue&type=script&lang=js"
export * from "./myBanner.vue?vue&type=script&lang=js"
import style0 from "./myBanner.vue?vue&type=style&index=0&id=0d545da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d545da4",
  null
  
)

export default component.exports